import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {SiteModel} from '../../models/site.model';
import {ContactModel} from '../../models/contact.model';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {AlertController, IonContent, ModalController} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {PhotoDTOModel} from '../../models/photoDTO.model';
import {ValidateDocumentService} from '../../services/validate-document.service';
import {GeneralSaveDocumentService} from '../../services/general-save-document.service';
import { DocumentTypes } from 'src/app/definitions/document-types';
import { LiveContractResourceService } from 'src/app/services/database/resource/live-contract-resource.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ConfigurationModel } from 'src/app/models/configuration.model';

@Component({
    selector: 'app-simple-contract',
    templateUrl: './simple-contract.page.html',
    styleUrls: ['./simple-contract.page.scss'],
})

export class SimpleContractPage implements OnInit {

    @ViewChild('content') content: IonContent;
    @Input() document: DocumentModel;
    documentTemp: DocumentModel;
    title: string;
    contractNumber: number;
    configuration: ConfigurationModel;

    constructor(private alertController: AlertController,
                private modalController: ModalController,
                private validateDoc: ValidateDocumentService,
                private generalSaveDocumentService: GeneralSaveDocumentService,
                private docTypes: DocumentTypes,
                private liveContractResourceService: LiveContractResourceService,
                private configurationService: ConfigurationService) {
    }

    ngOnInit() {
        this.documentTemp = JSON.parse(JSON.stringify(this.document));
        this.configuration = this.configurationService.getConfiguration();
    }

    ionViewDidEnter(){
        this.content.scrollToTop(200);
    }

    ionViewWillEnter() {
        

        if( this.document.documentType === this.docTypes.LOAN ){
            this.title = 'Loan';
        }else{
            this.title = 'Contract';
        }
    }

    async handleLoadContract(){
        this.document = await this.liveContractResourceService.getContractForLocationAndContract(this.configuration.selectedDepot, this.contractNumber) as DocumentModel;
        // set this as a simple modify contract
        this.document.originalDocumentType = this.document.documentType;
        this.document.documentType = 8;
        this.documentTemp = JSON.parse(JSON.stringify(this.document));

        console.log(this.contractNumber);
    }

    listenDocument(event: DocumentModel) {
        if (event.documentType === 0) {
            this.documentTemp = event;
        } else {
            const docTypeTemp = this.document.documentType;
            this.documentTemp = event;
            this.documentTemp.documentType = docTypeTemp;
        }
        if (!(this.documentTemp.photosURL)) {
            this.documentTemp.photosURL = new Array<PhotoDTOModel>();
        }
    }

    listenCustomer(event) {
        this.documentTemp.customer = event;
        this.documentTemp.contact = new ContactModel();
        this.documentTemp.signatureContact = new ContactModel();
        this.documentTemp.site = new SiteModel();
        this.documentTemp.signature = null;
        this.documentTemp.detailLines = new Array<DetaillineDTOModel>();
    }

    listenSignature(event: string) {
        if (event) {
            this.documentTemp.queuedToOperatorId = null;
        }
    }

    saveContract() {
        // when saving contract we need to set the creation date equal to scheduled date,
        this.documentTemp.creationDate = this.documentTemp.scheduledDate;
        if (!this.validateDoc.isValid(this.documentTemp)) {
            return;
        } else {
            this.document = JSON.parse(JSON.stringify(this.documentTemp));
            this.generalSaveDocumentService.generalSaveDocument(this.document);
        }
    }

    async cancelContract() {
        if (JSON.stringify((this.document)) !== JSON.stringify(this.documentTemp)) {
            const alert = await this.alertController.create({
                message: 'Do you want to cancel the ' + this.title + ' ?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                        }
                    }, {
                        text: 'Yes',
                        handler: () => {
                            this.modalController.dismiss();
                        }
                    }
                ]
            });
            await alert.present();
        } else {
            this.modalController.dismiss();
        }
    }
}
